export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-01B.e82ba1a2.png";